import { StatDetailInfo } from '@/common/components/organisms/statWindow';
import { StatId } from '@/common/components/organisms/statWindow/statContents/statContents.setup';
import { useStatInfoStore } from '@/common/stores/stat-info';
import { uniq } from 'lodash-es';
import { defineStore, storeToRefs } from 'pinia';
import { computed, ComputedRef, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useMetricInfo } from '@/dashboard/features/widgetFrame/components/statInformation/statInformation.setup';

export const useStatDetailStore = defineStore('statDetailStore', () => {
  const statDetailInfos = ref<Map<StatId, StatDetailInfo>>(new Map());

  const appendStatDetailInfos = (_statDetailInfos: StatDetailInfo[]) => {
    _statDetailInfos.forEach((statDetailInfo) => {
      statDetailInfos.value.set(statDetailInfo.id, statDetailInfo);
    });
  };

  const route = useRoute();
  const dashboardId = computed(() => route.params.id as string);

  watch(dashboardId, () => {
    statDetailInfos.value = new Map();
  });

  return { statDetailInfos, appendStatDetailInfos };
});

export const useSetStatDetailInfos = (
  statList: ComputedRef<{ dataId: string; category: string }[]>,
) => {
  const statInfoStore = useStatInfoStore();

  const statDetailStore = useStatDetailStore();
  const { statDetailInfos } = storeToRefs(statDetailStore);
  const { appendStatDetailInfos } = statDetailStore;

  const queryManagerStatIds = computed<string[]>(() =>
    uniq(
      statList.value
        ?.filter(
          ({ dataId, category }) =>
            !!dataId && statInfoStore.getStatInfo({ statId: dataId, childCategory: category }),
        )
        .map((item) => item.dataId!) ?? [],
    ),
  );

  const statIdsToFetchDetail = computed(() => {
    return queryManagerStatIds.value.filter((id) => !statDetailInfos.value.has(id));
  });

  const { metricInfoList, refetch: refetchStatDetailInfo } = useMetricInfo(
    computed(() => statIdsToFetchDetail.value),
    {
      enabled: false,
    },
  );

  const setStatDetailInfos = async () => {
    if (statIdsToFetchDetail.value.length > 0) {
      try {
        await refetchStatDetailInfo();
        appendStatDetailInfos(metricInfoList.value ?? []);
      } catch {
        console.error('stat detail info fetch error');
      }
    }
  };

  return { setStatDetailInfos };
};
